import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";
import PurchasePo from "../views/purchase/po/view";
import { PoDetails } from "../views/purchase/po/view/details";

import PurchaseRo from "../views/purchase/ro/view";
import { PurchaseRoDetails } from "../views/purchase/ro/view/details";
//维修预约
import Appointment from "../views/business/appointment/view";
import { AppointmentDetails } from "../views/business/appointment/view/details";


import Maintenance from "../views/business/maintenance/view";
import { MaintenanceDetails } from "../views/business/maintenance/view/details";
//维修退单
import Chargeback from "../views/business/chargeback/view";
import { ChargebackDetails } from "../views/business/chargeback/view/details";

// import SaleOrder from "../views/sale/order/view";
// import { SaleOrderDetails } from "../views/sale/order/view/details";
// import SaleSo from "../views/sale/so/view";
// import { SaleSoDetails } from "../views/sale/so/view/details";
// import SaleRo from "../views/sale/ro/view";
// import StockStatistic from "../views/stock/statistic/view";
//业务开单

// 配件销售
import SaleSo from "../views/business/sale/so/view";
import { SaleSoDetails } from "../views/business/sale/so/view/details"
//销售退货
import SaleRo from "../views/business/sale/ro/view";
import { SaleRoDetails } from "../views/business/sale/ro/view/details"

// 销售订单
import SaleOrder from "../views/business/sale/order/view";
import { SaleOrderDetails } from "../views/business/sale/order/view/details"
//库存统计
import StockStatistic from "../views/stock/statistic/view/index";
import StockStatisticDetails from "../views/stock/statistic/view/details";


//库存盘点
import StockCheck from "../views/stock/check/view";
import { CheckDetail } from "../views/stock/check/view/details/index";
//出库单据
import StockOutput from "../views/stock/output/view";
import { OutputDetails } from "../views/stock/output/view/details/index";
//入库单据
import StockEntry from "../views/stock/entry/view";
import { EntryDetails } from "../views/stock/entry/view/details/index";

import Error404 from "../views/404";

//字典
import BaseGoods from "../views/base/goods/view";
import { BaseGoodsDetails } from "../views/base/goods/view/DetailsBox";
import { BaseWarehouse } from "../views/base/warehouse/view";
import { WarehouseDatalis } from "../views/base/warehouse/view/editDetails"
import { BaseSupplier } from "../views/base/supplier/view";
import { BaseSupplierDetails } from "../views/base/supplier/view/DetailsBox";
// import { BaseCustomer } from "../views/base/customer/view";
import { BaseCustomer } from "../views/base/customerFiles/customer/view";
import { BaseCustomerDetails } from "../views/base/customerFiles/customer/view/DetailsBox";

import BaseVehicle from "../views/base/customerFiles/vehicle/view";
import { BaseVehicleDetails } from "../views/base/customerFiles/vehicle/view/DetailsBox";
//维修项目
import BaseItem from "../views/base/item/view";
import { BaseItemDetails } from "../views/base/item/view/DetailsBox";
// 维修技师
import TechnicianItem from "../views/base/technician/view";
import { BaseDict } from "../views/base/dict/view";

import Material from "../views/base/material/view"
import { MaterialDetails } from "../views/base/material/view/DetailsBox"

//系统配置
//角色设置
import Roles from "../views/system/roles/view"
//员工设置
import Staff from "../views/system/staff/view"
//账户管理
//客户账户
import { AccountCustomer } from "../views/account/customerManage/view/index"
import { CustomerAccountDetail as CustomerAccountDetailManage } from "../views/account/customerManage/view/detail";
//供应商账户
import { AccountSupplier } from "../views/account/supplierManage/view/index"
import { SupplierAccountDetail as SupplierAccountDetailManage } from "../views/account/supplierManage/view/detail";
//统计分析
//出入汇总
import StatisticsInAndOut from "../views/statistics/inAndOut/view"
//技师业绩
import StatisticsTechnician from "../views/statistics/technician/view"
import StatisticsTechnicianDetails from "../views/statistics/technician/view/details"

//应收统计
import StatisticsReceivable from "../views/statistics/receivable/view"
//应付统计
import StatisticsPayable from "../views/statistics/payable/view"
//营业额
import StatisticsTurnover from "../views/statistics/turnover/view"
//销售额
import StatisticsSales from "../views/statistics/sales/view"
//维修额
import StatisticsMaintenance from "../views/statistics/Maintenance/view"
function VrmRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="1" component={Home} />
            {/* 采购管理 */}
            <Route exact={true} path={"/purchase/po"} key="3-1" component={PurchasePo} />
            <Route exact={true} path={"/purchase/po/add"} key="3-1-1" component={PoDetails} />
            <Route exact={true} path={"/purchase/po/edit"} key="3-1-2" component={PoDetails} />
            <Route exact={true} path={"/purchase/po/look"} key="3-1-3" component={PoDetails} />
            {/* 采购退货 */}
            <Route exact={true} path={"/purchase/ro"} key="3-2" component={PurchaseRo} />
            <Route exact={true} path={"/purchase/ro/add"} key="3-2-1" component={PurchaseRoDetails} />
            <Route exact={true} path={"/purchase/ro/edit"} key="3-2-2" component={PurchaseRoDetails} />
            <Route exact={true} path={"/purchase/ro/look"} key="3-2-2" component={PurchaseRoDetails} />
            {/* 业务开单 */}
            {/* 配件销售 */}
            <Route exact={true} path={"/business/saleSo"} key="2-3" component={SaleSo} />
            <Route exact={true} path={"/business/saleSo/add"} key="2-3-1" component={SaleSoDetails} />
            <Route exact={true} path={"/business/saleSo/edit"} key="2-3-2" component={SaleSoDetails} />
            <Route exact={true} path={"/business/saleSo/look"} key="2-3-3" component={SaleSoDetails} />
            {/* 销售退货 */}
            <Route exact={true} path={"/business/saleRo"} key="2-4" component={SaleRo} />
            <Route exact={true} path={"/business/saleRo/add"} key="2-4-3" component={SaleRoDetails} />
            <Route exact={true} path={"/business/saleRo/edit"} key="2-4-3" component={SaleRoDetails} />
            <Route exact={true} path={"/business/saleRo/look"} key="2-4-3" component={SaleRoDetails} />
            {/* 销售订单 */}
            <Route exact={true} path={"/business/saleOrder"} key="2-6" component={SaleOrder} />
            <Route exact={true} path={"/business/saleOrder/add"} key="2-6-1" component={SaleOrderDetails} />
            <Route exact={true} path={"/business/saleOrder/edit"} key="2-6-2" component={SaleOrderDetails} />
            <Route exact={true} path={"/business/saleOrder/look"} key="2-6-3" component={SaleOrderDetails} />

            {/* 维修预约 */}
            <Route exact={true} path={"/business/appointment"} key="2-1" component={Appointment} />
            <Route exact={true} path={"/business/appointment/add"} key="2-1-1" component={AppointmentDetails} />
            <Route exact={true} path={"/business/appointment/edit"} key="2-1-2" component={AppointmentDetails} />
            <Route exact={true} path={"/business/appointment/look"} key="2-1-3" component={AppointmentDetails} />

            {/* 维修开单 */}
            <Route exact={true} path={"/business/maintenance"} key="2-2" component={Maintenance} />
            <Route exact={true} path={"/business/maintenance/add"} key="2-2-1" component={MaintenanceDetails} />
            <Route exact={true} path={"/business/maintenance/edit"} key="2-2-2" component={MaintenanceDetails} />
            <Route exact={true} path={"/business/maintenance/look"} key="2-2-3" component={MaintenanceDetails} />
            {/* 维修退单 */}
            <Route exact={true} path={"/business/chargeback"} key="2-5" component={Chargeback} />
            <Route exact={true} path={"/business/chargeback/add"} key="2-5-1" component={ChargebackDetails} />
            <Route exact={true} path={"/business/chargeback/edit"} key="2-5-2" component={ChargebackDetails} />
            <Route exact={true} path={"/business/chargeback/look"} key="2-5-3" component={ChargebackDetails} />

            {/* 
            <Route exact={true} path={"/sale/order"} key="3-1" component={SaleOrder} />
            <Route exact={true} path={"/sale/order/add"} key="3-1-1" component={SaleOrderDetails} />
            <Route exact={true} path={"/sale/order/edit"} key="3-1-2" component={SaleOrderDetails} />
            <Route exact={true} path={"/sale/so"} key="3-2" component={SaleSo} />
            <Route exact={true} path={"/sale/so/add"} key="3-2-1" component={SaleSoDetails} />
            <Route exact={true} path={"/sale/so/edit"} key="3-2-2" component={SaleSoDetails} />
            <Route exact={true} path={"/sale/ro"} key="3-3" component={SaleRo} />
            <Route exact={true} path={"/stock/statistic"} key="4-1" component={StockStatistic} /> */}
            {/* 库存统计 */}
            <Route exact={true} path={"/stock/statistic"} key="4-1" component={StockStatistic} />
            <Route exact={true} path={"/stock/statistic/look"} key="4-1-3" component={StockStatisticDetails} />


            {/* 库存盘点 */}
            <Route exact={true} path={"/stock/check"} key="4-2" component={StockCheck} />
            <Route exact={true} path={"/stock/check/add"} key="4-2-1" component={CheckDetail} />
            <Route exact={true} path={"/stock/check/edit"} key="4-2-2" component={CheckDetail} />
            <Route exact={true} path={"/stock/check/look"} key="4-2-3" component={CheckDetail} />


            {/* 出库单据 */}
            <Route exact={true} path={"/stock/output"} key="4-4" component={StockOutput} />
            <Route exact={true} path={"/stock/output/look"} key="4-4-3" component={OutputDetails} />
            {/* 入库单据 */}
            <Route exact={true} path={"/stock/entry"} key="4-3" component={StockEntry} />
            <Route exact={true} path={"/stock/entry/look"} key="4-2-3" component={EntryDetails} />

            {/* 基础数据 供应商 */}
            <Route exact={true} path={"/base/supplier"} key="13-1" component={BaseSupplier} />
            <Route exact={true} path={"/base/supplier/add"} key="13-1-1" component={BaseSupplierDetails} />
            <Route exact={true} path={"/base/supplier/edit"} key="13-1-2" component={BaseSupplierDetails} />
            {/* 配件管理 */}
            <Route exact={true} path={"/base/material"} key="13-2" component={Material} />
            <Route exact={true} path={"/base/material/add"} key="13-2-1" component={MaterialDetails} />
            <Route exact={true} path={"/base/material/edit"} key="13-2-2" component={MaterialDetails} />
            {/* 仓库 */}
            <Route exact={true} path={"/base/warehouse"} key="13-3" component={BaseWarehouse} />
            <Route exact={true} path={"/base/warehouse/details"} key="13-3-1" component={WarehouseDatalis} />
            {/* 客户 */}
            <Route exact={true} path={"/base/customerFiles/customer"} key="13-5-1" component={BaseCustomer} />
            <Route exact={true} path={"/base/customerFiles/customer/add"} key="13-5-1-1" component={BaseCustomerDetails} />
            <Route exact={true} path={"/base/customerFiles/customer/edit"} key="13-5-1-2" component={BaseCustomerDetails} />
            {/* 车辆 */}
            <Route exact={true} path={"/base/customerFiles/vehicle"} key="13-5-2" component={BaseVehicle} />
            <Route exact={true} path={"/base/customerFiles/vehicle/add"} key="13-5-2-1" component={BaseVehicleDetails} />
            <Route exact={true} path={"/base/customerFiles/vehicle/edit"} key="13-5-2-2" component={BaseVehicleDetails} />
            {/* 维修形目 */}
            <Route exact={true} path={"/base/item"} key="13-6" component={BaseItem} />
            <Route exact={true} path={"/base/item/add"} key="13-6-1" component={BaseItemDetails} />
            <Route exact={true} path={"/base/item/edit"} key="13-6-2" component={BaseItemDetails} />
            {/* 维修技师 */}
            <Route exact={true} path={"/base/technician"} key="13-6" component={TechnicianItem} />

            {/* 数据字典 */}
            <Route exact={true} path={"/base/dict"} key="13-4" component={BaseDict} />
            {/* 系统设置 */}
            <Route exact={true} path={"/system/roles"} key="14-1" component={Roles} />
            <Route exact={true} path={"/system/staff"} key="14-2" component={Staff} />
            <Route exact={true} path={"/account/customerManage"} key="15-1" component={AccountCustomer} />
            <Route exact={true} path={"/account/customerManage/detail"} key="15-1-1" component={CustomerAccountDetailManage} />

            <Route exact={true} path={"/account/supplierManage"} key="15-2" component={AccountSupplier} />
            <Route exact={true} path={"/account/supplierManage/detail"} key="15-2-1" component={SupplierAccountDetailManage} />

            {/* 统计分析 */}
            <Route exact={true} path={"/statistics/inAndOut"} key="16-1" component={StatisticsInAndOut} />
            <Route exact={true} path={"/statistics/technician"} key="16-2" component={StatisticsTechnician} />
            <Route exact={true} path={"/statistics/technician/look"} key="16-2-3" component={StatisticsTechnicianDetails} />
            <Route exact={true} path={"/statistics/receivable"} key="16-3" component={StatisticsReceivable} />
            <Route exact={true} path={"/statistics/payable"} key="16-4" component={StatisticsPayable} />
            <Route exact={true} path={"/statistics/turnover"} key="16-5" component={StatisticsTurnover} />
            <Route exact={true} path={"/statistics/sales"} key="16-6" component={StatisticsSales} />
            <Route exact={true} path={"/statistics/Maintenance"} key="16-7" component={StatisticsMaintenance} />
            
            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default VrmRoute;